module.exports = __webpack_public_path__ + "static/media/1.86f30a79.jpg";